import { render, staticRenderFns } from "./Split.vue?vue&type=template&id=3ed998d4&scoped=true&"
import script from "./Split.vue?vue&type=script&lang=js&"
export * from "./Split.vue?vue&type=script&lang=js&"
import style0 from "./Split.vue?vue&type=style&index=0&id=3ed998d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed998d4",
  null
  
)

/* custom blocks */
import block0 from "./Split.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "Split.vue"
export default component.exports